import React from "react";
import { Box, Grid } from "@mui/material";
import ClientHeader from "./ClientHeader";
import StatsCards from "./StatsCards";
import ProgressSection from "./ProgressSection";
import CampaignDetailsNode from "./GigTreeDetails";
import { CampaignResponse } from "../../../types/types";

interface CampaignDetailsProps {
  campaigns: CampaignResponse | undefined;
  gigId: string;
  loading: boolean;
}


const ClientDetails = ({ campaigns, gigId, loading }: CampaignDetailsProps) => {
  if (!campaigns) return null;
  return (
    <Box>
      <ClientHeader campaigns={campaigns.campaign} gigId={gigId} />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <StatsCards campaigns={campaigns.campaign} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampaignDetailsNode data={campaigns.children} loading={loading} />
        </Grid>
        <Grid item xs={12}>
          <ProgressSection campaigns={campaigns.campaign} gigId={gigId} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClientDetails;
